// DOM ids
export const ANALYZE_FRAMEWORK = 'analyzeFramework'
export const COLLABORATE = 'collaborate'
export const COLLABORATION_SESSION_NAME = 'collaborationSessionName'
export const DEMOGRAPHIC_ANALYSIS = 'demographic-analysis'
export const DOCUMENTATION_LINK = 'documentationLink'
export const FRAMEWORK_INFO = 'frameworkHelp'
export const INSTR_BRUSHING_LINK = 'brushing'
export const INSTR_INTRO_LINK = 'introduction'
export const INSTR_DESCRIP_LINK = 'description'
export const INSTR_MAP_LINK = 'map'
export const INSTR_SETTINGS_LINK = 'settings'
export const INSTR_USAGE_LINK = 'usage'
export const INSTR_USAGE_ANALYZE_LINK = 'usage/analyze'
export const INSTR_USAGE_BRUSHING_LINK = 'usage/brushing'
export const INSTR_USAGE_FRAMEWORKS_LINK = 'usage/frameworks'
export const INSTR_REFERENCES_LINK = 'references'
export const INSTR_FRAMEWORK_LINK = 'frameworkDoc'
export const INSTR_FRAMEWORK_URL_LINK = 'frameworkUrl'
export const REFUGEE_MODEL = 'refugee-model'
export const SETTINGS = 'settings'
export const SELECT_BOOKMARK = 'selectBookark'
export const SELECT_FRAMEWORK = 'selectFramework'
export const SUBHEADER_COLLABORATE = 'subheaderCollaborate'
export const SUBHEADER_DOCS = 'subheader/docs'
export const SUBHEADER_SELECT_BOOKMARK = 'subheaderSelectBookmark'
export const SUBHEADER_SELECT_FRAMEWORK = 'subheaderSelectFramework'
export const SUBHEADER_ANALYZE_FRAMEWORK = 'SUBHEADER_ANALYZE_FRAMEWORK'
export const THEME_CALCULATOR = 'THEME_CALCULATOR'
export const TRANSIMS = 'TRANSIMS'
